<div *ngIf="this.viewSession === 1">
  <div class="basicrow f-lsemi roboto-r text-center">
      <div class="basicrow">
          <img width="100%" class="mc-icon" src="../../assets/images/reg-a-icon.png">
          Registro 
      </div>
      <!-- <div class="basicrow m-top-ii">
          <div class="logline"></div>
      </div> -->
  </div>
  <div>
      <div class="basicrow m-top-i">
          <label class="label-f">N&uacute;mero de Tel&eacute;fono</label>
          <div class="basicrow">
              <img data-toggle="popover" data-html="true" data-content="Número de Teléfono celular o fijo."
              data-placement="bottom" class="q-t-pay" width="100%"  src="../../assets/images/tooltip1.png" style="width: 30px;height: 30px;right: 5%;top: 5%;">
              <input type="text" maxlength="10" class="inp-f" [(ngModel)]="this.subscriber">
          </div>
      </div>

      <div class="basicrow m-top-i">
          <a (click)="this.submitForm();" class="btns red vcenter">
              <span class="tabcell">
                  Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
              </span>
          </a>
      </div>
  </div>
</div>